import GoalError from './GoalError';
class AmountBelowPatrimonyAccountValue extends GoalError {
    constructor(options) {
        super('The target amount of the goal is less than investor’s'
            + ' account value when goal type is for PATRIMONY', options);
    }
}
export default AmountBelowPatrimonyAccountValue;
